import { asm } from './asm';

export const frCA = { asm };
